module.exports = __webpack_public_path__ + "img/2_24.bf650108.png";